import { routes as auth } from "@/modules/auth";
import { routes as home } from "@/modules/main";

export default [...home, ...auth];
